import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    index: 1,
    component: () => import('../views/WholeDelivery/index.vue')
  },
  {
    path: '/DDU&DDP',
    name: 'DDU&DDP',
    index: 2,
    component: () => import('../views/DDU&DDP/index.vue')
  },
  {
    path: '/FBA',
    name: 'FBA',
    index: 3,
    component: () => import('../views/FBA/index.vue')
  },
  {
    path: '/Info',
    name: 'info',
    index: 4,
    component: () => import('../views/clearance/index.vue')
  },
  {
    path: '/delivery',
    name: 'delivery',
    index: 5,
    component: () => import('../views/delivery/index.vue')
  },
  {
    path: '/tax',
    name: 'tax',
    index: 6,
    component: () => import('../views/tax/index.vue')
  },



]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
